import { Dialog } from "primereact/dialog";
import React from "react";
import CustomeButton from "~/components/Button";

const UserDeleteDialog = ({
  selectedUser,
  handleDelete,
  setOpenDialog,
  loading = false,
  open = false,
}) => {
  return (
    <Dialog visible={open} className="delete__user">
      <p className="delete__user--title">
        Do you want to delete "{selectedUser?.first_name}{" "}
        {selectedUser?.last_name}"?
      </p>
      <p className="delete__user--subtitle">
        This action will permanently remove their access to the platform.
      </p>
      <div className="flex justify-content-end">
        <CustomeButton
          label={"Cancel"}
          variant="outlined"
          className="access-btn"
          onClick={() => setOpenDialog(false)}
          disabled={loading}
        />
        <CustomeButton
          label={"Yes, Delete"}
          variant="remove"
          className="access-btn confirm__delete"
          onClick={() => handleDelete(selectedUser?.id)}
          disabled={loading}
          loading={loading}
        />
      </div>
    </Dialog>
  );
};

export default UserDeleteDialog;
